import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { JWTService } from './jwt.service';
import { Page } from './page';

/**
 * Manages the call to /self to get a jwt token (if we don't have one yet) and a bit of data about the page for which we chat
 * (frame chat title and avatar icon, mainly)
 *
 * Note: do not conflate the jwt used to authenticate ourselves with the backend (the one handled by the JWTService),
 * and the externalAuthJWT passed by the host page/app so that they can identify the end-user in Alcméon
 */
@Injectable({
  providedIn: 'root',
})
export class PageService {
  fakeBackgroundImageBS: BehaviorSubject<string> = new BehaviorSubject(null);

  private SERVER_URL = environment.apiURLPrefix;
  private pageId: string;
  private externalAuthJWT: string;
  // Fetches the pageId from the URL
  constructor(
    private httpClient: HttpClient,
    private jwtService: JWTService
  ) {
    const urlParams = new URLSearchParams(window.location.search);
    this.pageId = urlParams.get('page-id');
    this.externalAuthJWT = urlParams.get('jwt');

    if (!this.pageId) {
      console.log(`inmessage - no page-id param in URL ${window.location.href}`);
    }
  }

  getPageInfo(): Observable<Page> {
    const hasExternalToken = !!this.externalAuthJWT;
    const endpointSuffix = hasExternalToken ? '/authenticate' : '/self';
    const endpoint = this.SERVER_URL + this.getPageId() + endpointSuffix;
    let headersConf;
    if (hasExternalToken) {
      headersConf = { Authorization: `Bearer ${this.externalAuthJWT}` };
    }
    const httpOptions = {
      headers: new HttpHeaders(headersConf),
    };
    return this.httpClient.get<Page>(endpoint, httpOptions).pipe(
      tap(page => {
        this.jwtService.setJwt(page.jwt);
        page.persistent_menu = page.persistent_menu || [];
        if (/^https:\/\/(admin-dev[\d|a-z]\.)?(demo\.)?alcmeon.com/.test(document.referrer)) {
          this.getDemoBackgroundImage().subscribe();
        }
      })
    );
  }

  getPageId() {
    return this.pageId;
  }

  getDemoBackgroundImage(): Observable<any> {
    return this.httpClient
      .get(`${environment.apiURLPrefix}${this.pageId}/demo-background-image`, {
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(
        filter((response: HttpResponse<Blob>) => response.status === 200),
        tap((response: HttpResponse<Blob>) => {
          const result = response.body;
          const reader = new FileReader();
          reader.onload = () => {
            const dataUrl = reader.result as string;
            this.fakeBackgroundImageBS.next(dataUrl);
          };
          reader.readAsDataURL(result);
        })
      );
  }
}
